import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import * as productSearchActions from './productSearchActions';
import {MIN_PASSENGERS, MAX_PASSENGERS} from './productSearchPassengerConstants';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class ProductSearchFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      airportRegions: [
        {
          name: 'manhattan',
          airportCodes: ['EWR', 'JFK'],
          cityStationCodes: ['E34', 'JRA', 'JRB', 'MANH', 'NYCA']
        }
      ]
    };
    this.decrementPassengers = this.decrementPassengers.bind(this);
    this.incrementPassengers = this.incrementPassengers.bind(this);
    this.onOriginClick = this.onOriginClick.bind(this);
    this.onDestinationClick = this.onDestinationClick.bind(this);
    this.onBackButtonClick = this.onBackButtonClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.redirect_to_airport_flow = this.redirect_to_airport_flow.bind(this);
    this.newSearchFlow = this.newSearchFlow.bind(this);
    this.setFlightAlert = this.setFlightAlert.bind(this);
  }

  decrementPassengers() {
    this.props.actions.selectPassengerQuantity(this.props.passenger_quantity - 1);
  }

  incrementPassengers() {
    this.props.actions.selectPassengerQuantity(this.props.passenger_quantity + 1);
  }

  setFlightAlert() {
    this.props.actions.setFlightAlert(!this.props.set_flight_alert);
  }

  onBackButtonClick() {
    history.back();
  }

  onNextClick() {
    $(".see-flights").html("<i class='fa fa-spin fa-spinner fa-lg'></i>");

    let originCode = this.props.origin_station_result.code;
    let destinationCode = this.props.destination_station_result.code;
    let passengerQuantity = this.props.passenger_quantity;

    const redirected = this.state.airportRegions.some(region => {
      const airportCodes = region.airportCodes;
      const cityStationCodes = region.cityStationCodes;

      if (airportCodes.includes(originCode) && cityStationCodes.includes(destinationCode)) {
        this.redirect_to_airport_flow({
          code: originCode,
          juncture: 'arrivals',
          direction: 'city',
          region: region.name,
          passengers: passengerQuantity,
          origin: originCode,
          destination: destinationCode
        });
        return true;
      }
      else if (cityStationCodes.includes(originCode) && airportCodes.includes(destinationCode)) {
        this.redirect_to_airport_flow({
          code: destinationCode,
          juncture: 'arrivals',
          direction: 'airport',
          region: region.name,
          passengers: passengerQuantity,
          origin: originCode,
          destination: destinationCode
        });
        return true;
      }
    });

    if (redirected) return;
    this.props.actions.broadcastSubmittedSearchForm();
    this.newSearchFlow();
  }

  redirect_to_airport_flow(airportInfo) {
    window.location.href = `/airport_bookings/${airportInfo.region}/${airportInfo.juncture}/new?` +
      `origin=${airportInfo.origin}&` +
      `destination=${airportInfo.destination}&` +
      `airport=${airportInfo.code}&` +
      `direction=${airportInfo.direction}&` +
      `passengers=${airportInfo.passengers}`;
  }

  newSearchFlow() {
    window.location.href = `/flight_search/choose_date?` +
      `origin=${this.props.origin_station_result.code}&` +
      `destination=${this.props.destination_station_result.code}&` +
      `passengers=${this.props.passenger_quantity}&` +
      `set_flight_alert=${this.props.set_flight_alert}`
  }

  valid() {
    return (!!this.props.origin_station_result) &&
      (!!this.props.destination_station_result);
  }

  onOriginClick() {
    this.props.actions.openOrigins({back: 'ProductSearch'});
  }

  onDestinationClick() {
    this.props.actions.openDestinations({back: 'ProductSearch'});
  }

  render() {
    let origin = !!this.props.origin_station_result
      ? this.props.origin_station_result.title
      : i18n.t('productSearch.enterOrigin');

    let destination = this.props.destination_station_result
      ? this.props.destination_station_result.title
      : i18n.t('productSearch.enterDestination');

    return (
      <div className="product-search-step">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.onBackButtonClick}/>}
          title={"Search Flights"}
          additionalClasses={['clear', 'floating-layout']}/>

        <h1 className="web-title text-center">{i18n.t('productSearch.searchFlights')}</h1>
        <div className="product-search-form">

          <div className="form-params">
            <div
              className={classnames(
                'form-text-param',
                {
                  'empty': !this.props.origin_station_result
                }
              )}
              onClick={this.onOriginClick}>
              <div>
                { this.props.origin_station_result && <label>{i18n.t('productSearch.origin')}</label> }
                <p>{origin}</p>
              </div>
            </div>

            <a className="form-divider-icon btn btn-pseudo" title="Swap direction"
            onClick={this.props.actions.swapStationValues}>
              <div className="swap-stations-icon"></div>
            </a>


            <div
              className={classnames(
                'form-text-param',
                {
                  'empty': !this.props.destination_station_result
                }
              )}
              onClick={this.onDestinationClick}>
              <div>
              { this.props.destination_station_result && <label>{i18n.t('productSearch.destination')}</label> }
                <p>{destination}</p>
              </div>
            </div>

            <div className="quantity-picker text-center">
              <label>{i18n.t('productSearch.passengers')}</label>
              <div>
                <div
                  className={classnames(
                    'control',
                    'btn',
                    'btn-pseudo',
                    {disabled: this.props.passenger_quantity === MIN_PASSENGERS}
                  )}
                  onClick={this.decrementPassengers}>
                  –
                </div>
                <span className='quantity'>
                  {this.props.passenger_quantity}
                </span>
                <div
                  className={classnames(
                    'control',
                    'btn',
                    'btn-pseudo',
                    {disabled: this.props.passenger_quantity === MAX_PASSENGERS}
                  )}
                  onClick={this.incrementPassengers}>
                  +
                </div>
              </div>
            </div>
          </div>

          <div className="see-flight-wrapper">
            <button
              className="btn btn-primary btn-block see-flights"
              onClick={this.onNextClick}
              disabled={!this.valid()}
            >
              {i18n.t('productSearch.next')}
            </button>
          </div>
          <hr/>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    origin_station_result: state.productSearch.origin_station_result,
    destination_station_result: state.productSearch.destination_station_result,
    passenger_quantity: state.productSearch.passenger_quantity,
    set_flight_alert: state.productSearch.set_flight_alert
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductSearchFormContainer)
